export default __webpack_public_path__ + "static/media/eBalance-logo.7d1783eb.png";